import React from 'react';

import {IconButton} from '@mui/material';

import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export const ItemMenu = props => {
  const [posChecked, setPosChecked] = React.useState(props.locked);

  const [hiddenChecked, setHiddenChecked] = React.useState(props.hidden);

  const handleLockClicked = () => {
    const value = !posChecked;
    if (props.item.inherited) {
      return;
    }
    props.onLock(value);
    setPosChecked(value);
  };
  const handleHideClicked = () => {
    const value = !hiddenChecked;
    props.onHide(value);
    setHiddenChecked(value);
  };
  return (
    <div className='item-menu'>
      <div className='box'></div>
      <div className='box'>
        <IconButton
          disabled={!props.item.data.hideable}
          size='small'
          onClick={() => handleHideClicked()}>
          {hiddenChecked ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
        </IconButton>
      </div>
      <div className='box'>
        <IconButton
          // disabled={(!props.item.data.movable&&props.item.inherited)}
          disabled={
            typeof props.item.inherited === 'undefined' &&
            !props.item.data.movable
          }
          size='small'
          onClick={() => handleLockClicked()}>
          {posChecked ? <LockIcon /> : <LockOpenIcon />}
        </IconButton>
      </div>
      <div className='box'>
        <IconButton
          size='small'
          defaultChecked={posChecked}
          onClick={() => props.onReset()}>
          <ReplayCircleFilledIcon />
        </IconButton>
      </div>
    </div>
  );
};
export const ItemInput = ({
  item,
  data: {key, value},
  callback,
  disabled,
  inherited
}) => {
  const [itemValue, setItemValue] = React.useState(value);

  const validateInputValue = value => {
    setItemValue(value);
  };
  const publicChange = () => {
    callback(item, {[key]: {value: parseFloat(itemValue)}});
    validateInputValue(parseFloat(itemValue).toString());
  };

  const privateChange = e => {
    validateInputValue(e.target.value ? e.target.value.replace(',', '.') : '');
  };

  React.useEffect(() => {
    setItemValue(value.toString());
  }, [value]);

  return (
    <div
      style={{
        backgroundColor: inherited ? 'rgb(255,255,255,0.35)' : 'transparent',
        height: '100%',
        display: 'flex',
        width: '100%'
      }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        {!disabled && (
          <input
            className='br-input'
            disabled={inherited}
            style={{
              border: 0,
              height: '100%',
              width: '100%',
              WebkitTextStrokeColor: 'red',
              WebkitTextStrokeWidth: '1px',
              fontSize: item.ui.fontSize * 0.58 + 'px',
              fontWeight: 700,
              pointerEvents: 'auto',
              textAlign: 'center',
              backgroundColor: 'transparent',
              color: 'white'
            }}
            value={itemValue}
            onFocus={e => {
              e.target.select();
            }}
            onChange={privateChange}
            onBlur={publicChange}
            onKeyPress={e => {
              if (e.key === 'Enter' || e.keyCode === 13) {
                publicChange();
              }
            }}
          />
        )}
      </div>
    </div>
  );
};
